import React from 'react'

import { NewsItemAttachment } from 'Types/emajinAPI'

import { Container } from './styles'

type Props = {
  data?: NewsItemAttachment
}

function BlogPostGalleryCard({ data }: Props) {
  if (!data) return null

  return (
    <Container
      height={[280, 280, 280, 320, 320, 370]}
      width={[280, 280, 280, 320, 320, 370]}
    >
      {data.url && <img alt="" src={data.url} />}
    </Container>
  )
}

export default BlogPostGalleryCard
